// extracted by mini-css-extract-plugin
module.exports = {"title":"EventSpeakerModal_title__2BHiK","avatar":"EventSpeakerModal_avatar__Y5BkQ","avatarImage":"EventSpeakerModal_avatarImage__gWynE"};